import { cn } from '@agnes/ui';
import { BaseComponentProps } from '@/components/BaseComponentProps';
import logoDefault from '@/assets/image/logo_default.png';
import logoMarkDefault from '@/assets/image/logo_mark_default.png';
import logoWhite from '@/assets/image/logo_white.png';
import { useTheme } from '@/stores/useTheme';

export interface BrandLogoProps extends BaseComponentProps {
  mode: 'default' | 'mark';
}

/**
 * Logo da Agnes para o header do sidebar. `mode="mark"` (sidebar fechado) usa
 * sempre a marca isolada, que funciona nos dois temas; aberto, segue o tema:
 * versão colorida no light e a branca no dark.
 * Ocupa o mesmo slot do AgnesTenantSwitcher: h-9, largura cheia aberto e w-9
 * fechado. `object-contain` preserva a proporção dos PNGs e evita esticar.
 */
export function BrandLogo({ mode, className, dataQa }: BrandLogoProps) {
  const theme = useTheme((s) => s.mode);

  const src = mode === 'mark' ? logoMarkDefault : theme === 'dark' ? logoWhite : logoDefault;

  return (
    <img
      src={src}
      alt="Agnes"
      data-qa={dataQa}
      className={cn('h-8 max-w-full object-contain', className)}
    />
  );
}
